import React from 'react';
import './contrato.scss';

import Label from '../../components/label';

class Contrato extends React.Component {

  render() {

    return (
      <section className="container">
        <div className="contrato">
          <div className="col">
            <Label type="title" label="Declaro" />
          </div>

          <div className="text-contrato">
            <h4>a)</h4>
            <p>
              Ter conhecimento da Lei 9.613/98 e da lei 12.683/2012 sobre os Crimes de Lavagem de Dinheiro, das Circulares 3.461/09 e 3.691/13, do Banco Central do Brasil, e da IN RFB 1.634, bem como suas alterações ou substituições posteriores;
            </p>
          </div>

          <div className="text-contrato">
            <h4>b)</h4>
            <p>
              Que são verdadeiras e exatas as informações prestadas para o preenchimento deste cadastro, sob as penas da Lei, em especial o art. 299 do Código Penal, e que me comprometo a informar no prazo de 05 (cinco) dias úteis quaisquer alterações que vierem a ocorrer em meus dados cadastrais, inclusive sobre eventual revogação dos poderes outorgados a procuradores, sob pena de serem considerados válidos os contratos de câmbio assinados pelo procurador desconstituído;
            </p>
          </div>

          <div className="text-contrato">
            <h4>c)</h4>
            <p>
              Que autorizo a B&T Corretora de Câmbio Ltda. a consultar as fontes de referências indicadas e inserir/solicitar informações relacionadas à minha pessoa, junto ao mercado financeiro e entidades cadastrais em geral, SERASA, SCPC ou qualquer outro órgão ou entidade assemelhada;
            </p>
          </div>

          <div className="text-contrato">
            <h4>d)</h4>
            <p>
              Que autorizo a B&T Corretora de Câmbio Ltda. a consultar informações sobre operações realizadas no mercado de câmbio, disponibilizadas pelo Banco Central do Brasil, conforme disposto no Artigo 1º, Inciso 1, da Resolução 3.920/10, bem como suas alterações posteriores;
            </p>
          </div>

          <div className="text-contrato">
            <h4>e)</h4>
            <p>
              Que os números de inscrição para fins fiscais são verdadeiros, válidos, corretos e completos;
            </p>
          </div>

          <div className="text-contrato">
            <h4>f)</h4>
            <p>
              Que autorizo esta instituição na qual mantenho relacionamento a fornecer as informações constantes deste documento e seus anexos, se houver, bem como os dados financeiros relativos ao relacionamento e aos meus contratos de câmbio, às autoridades brasileiras, incluindo ordens judiciais, administrativas ou regulatórias, bem como autoridades estrangeiras, conforme exigido nos termos da legislação aplicável no Brasil, dos acordos firmados pelo Brasil, ou ainda nos termos da legislação aplicável na(s) jurisdição(ções) na(s) qual(is) eu tenha nascido, ou das quais eu seja cidadão, nacional ou residente;
            </p>
          </div>

          <div className="text-contrato">
            <h4>g)</h4>
            <p>
              Que autorizo a B&T Corretora de Câmbio Ltda. a realizar atividades de intermediação em contratos de câmbio, conforme faculta o artigo 27 da Circular n.3.691/2013, do Banco Central do Brasil, bem como suas alterações ou substituições posteriores, desde que solicitado expressamente pela minha pessoa;
            </p>
          </div>

          <div className="text-contrato">
            <h4>h)</h4>
            <p>
              Que autorizo a B&T Corretora de Câmbio Ltda. a efetuar o registro das operações no RDE-ROF (Registro Declaratório Eletrônico - Módulo Registro de Operações Financeiras) e a edição dos Contratos de Câmbio no Sistema SISBACEN, disponibilizado pelo Banco Central do Brasil, sempre que exigidos e nos moldes definidos por lei/regulamentação vigente;
            </p>
          </div>

          <div className="text-contrato">
            <h4>i)</h4>
            <p>
              Ter ciência da obrigatoriedade de fornecer toda e qualquer documentação que seja absolutamente necessária para que a B&T Corretora de Câmbio Ltda. possa prestar os serviços de intermediação de operações de câmbio, quando solicitadas, bem como prover os documentos exigidos para cadastramento pelo Banco Central do Brasil para a interveniência em operações de câmbio, mantendo seus dados cadastrais atualizados pelo prazo de 05 (cinco) anos, contados a partir da liquidação da última operação de câmbio registrada no SISBACEN pela B&T Corretora de Câmbio Ltda.;
            </p>
          </div>

          <div className="text-contrato">
            <h4>j)</h4>
            <p>
              Ter ciência que, para realização das operações de intermediação em contratos de câmbio, devo nomear e constituir a B&T Corretora de Câmbio Ltda. como minha procuradora, para representar-me junto ao Banco Central do Brasil, com poderes para registro no SISBACEN-Transação RDE-ROF das operações de Financiamento de importação de mercadorias e empréstimos externos, ou outros que venham a ser solicitados;
            </p>
          </div>

          <div className="text-contrato">
            <h4>k)</h4>
            <p>
              Ter conhecimento de que a prestação dos serviços de intermediação em contratos de câmbio terá início a partir da solicitação da mesma e vigorará por tempo indeterminado;
            </p>
          </div>

          <div className="text-contrato">
            <h4>l)</h4>
            <p>
              Reconhecer que a relação decorrente dos serviços de intermediação possui, única e exclusivamente, natureza cível e que a prestação dos serviços não dará ensejo a qualquer vínculo empregatício ou de outra natureza entre o Cliente e a B&T Corretora de Câmbio Ltda.
            </p>
          </div>

          <div className="text-contrato">
            <h4>m)</h4>
            <p>
              Ter ciência que a prestação de serviços de intermediação em contratos de câmbio poderá ser rescindida a qualquer tempo, por quaisquer das partes, por meio de notificação extrajudicial por escrito, com antecedência mínima de 30 (trinta) dias, ressalvadas as obrigações em curso no momento da notificação;
            </p>
          </div>

          <div className="text-contrato">
            <h4>n)</h4>
            <p>
              Que as obrigações e os direitos da prestação de serviços de intermediação em contratos de câmbio não poderão ser cedidos e transferidos a terceiros sem prévia, expressa e por escrita anuência da outra parte;
            </p>
          </div>

          <div className="text-contrato">
            <h4>o)</h4>
            <p>
              Que para solução de conflitos oriundos da prestação de serviços de intermediação em contratos de câmbio, as partes elegem o Foro Central da Comarca da Cidade de São Paulo – SP, com a expressa renúncia à outro, por mais privilegiado que seja;
            </p>
          </div>

          <div className="text-contrato">
            <h4>p)</h4>
            <p>
              Que manterei meu endereço eletrônico (e-mail) devidamente atualizado para fins de recebimento e confirmação de contratos firmados com a B&T Corretora de Câmbio Ltda. e quaisquer empresas do seu grupo econômico. Declaro ainda que admito como válidos os meios de comprovação de autoria e integridade de documentos de forma eletrônica utilizados pela B&T Corretora de Câmbio Ltda. e quaisquer empresas do seu grupo econômico, na forma da legislação em vigor.
            </p>
          </div>

          <div className="col-25 button-contrato">
            <button onClick={() => { this.props.history.push('/resumo') }} className="previous">Voltar</button>
          </div>

        </div>
      </section>
    );
  }
}

export default Contrato;